export default (state = {}, action) => {
  switch (action.type) {
    case 'PANEL_GET_PUNCHOUT_N2_RULES': {
      return { ...state, punchOutN2Rules: action.punchOutN2Rules };
    }
    default:
      return state;
  }
};
